const __WEBPACK_NAMESPACE_OBJECT__ = require("next/dist/shared/lib/runtime-config.external.js");